import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TextModes } from '../../../components/ui/controls/text-input/text-input.component';

@Component({
  selector: 'app-owner-dialog',
  templateUrl: './owner-dialog.component.html',
  standalone: false,
})
export class OwnerDialogComponent {
  leadId: string | undefined;
  inputTextModes = TextModes;

  constructor(
    public dialogRef: MatDialogRef<OwnerDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      leadId: string;
    },
  ) {
    this.leadId = data.leadId;
  }

  btnSave_click() {
    this.dialogRef.close(true);
  }

  btnClose_click() {
    this.dialogRef.close(false);
  }
}
